export default "__VITE_ASSET__CJvY77de__"